// extracted by mini-css-extract-plugin
export default {"text":"PersonalData_text__9LyJa","link":"PersonalData_link__wowAk","mb":"PersonalData_mb__0MB86"};